import { initializeConnector } from '@web3-react/core';
import { MetaMask } from '@web3-react/metamask';
import { WalletConnect } from '@web3-react/walletconnect';
import { CoinbaseWallet } from '@web3-react/coinbase-wallet';
import { NETWORKS } from './contracts';

// MetaMask Connector
const [metaMask, metaMaskHooks] = initializeConnector<MetaMask>(
  (actions) => new MetaMask({ actions })
);

// WalletConnect Connector
const [walletConnect, walletConnectHooks] = initializeConnector<WalletConnect>(
  (actions) => new WalletConnect({
    actions,
    options: {
      rpc: {
        [NETWORKS.POLYGON_MAINNET.chainId]: NETWORKS.POLYGON_MAINNET.rpcUrl,
        // [NETWORKS.POLYGON_AMOY.chainId]: NETWORKS.POLYGON_AMOY.rpcUrl, 
      },
    },
  })
);

// Coinbase Wallet Connector
const [coinbaseWallet, coinbaseWalletHooks] = initializeConnector<CoinbaseWallet>(
  (actions) => new CoinbaseWallet({
    actions,
    options: {
       url: NETWORKS.POLYGON_MAINNET.rpcUrl,
     // url: NETWORKS.POLYGON_MAINNET.rpcUrl||process.env.REACT_APP_RPC_URL,
      appName: 'Whitelist Admin DApp',
      // Coinbase Wallet uses a single RPC URL and does not support the rpcUrls object.
      // If multi-chain support is required, it can be switched dynamically at runtime.
    },
  })
);

// All connectors
export const connectors: [any, any][] = [
  [metaMask, metaMaskHooks],
  [walletConnect, walletConnectHooks],
  [coinbaseWallet, coinbaseWalletHooks],
];

// Export individual connectors for component use
export { metaMask, walletConnect, coinbaseWallet };
export { metaMaskHooks, walletConnectHooks, coinbaseWalletHooks };